import { defaultFont } from 'themes'

const HiddenPickerSlot = () => null

const CALENDAR_TEXT = '#1C1B1F'
const CALENDAR_MUTED = '#5F6368'
const CALENDAR_SELECTED = '#0053FF'

export const desktopDatePickerPopperSx = {
  zIndex: 1500,
  '& .MuiPaper-root': {
    borderRadius: '16px',
    border: 'none',
    boxShadow:
      '0px 1px 2px rgba(0, 0, 0, 0.08), 0px 8px 24px rgba(0, 0, 0, 0.12)',
    overflow: 'hidden',
    fontFamily: defaultFont,
    color: CALENDAR_TEXT,
  },
  '& .MuiPickersLayout-toolbar, & .MuiPickersLayout-actionBar, & .MuiDialogActions-root': {
    display: 'none',
  },
  '& .MuiDateCalendar-root': {
    width: 320,
    fontFamily: defaultFont,
  },
  '& .MuiPickersCalendarHeader-root, & .MuiPickersCalendarHeader-label, & .MuiDayCalendar-weekDayLabel, & .MuiPickersDay-root, & .MuiPickersArrowSwitcher-button, & .MuiPickersCalendarHeader-switchViewButton': {
    fontFamily: `${defaultFont} !important`,
  },
  '& .MuiPickersCalendarHeader-label': {
    fontSize: 16,
    fontWeight: 700,
    color: CALENDAR_TEXT,
  },
  '& .MuiDayCalendar-weekDayLabel': {
    color: CALENDAR_MUTED,
    fontWeight: 400,
  },
  '& .MuiPickersDay-root': {
    fontWeight: 400,
    color: CALENDAR_TEXT,
  },
  '& .MuiPickersDay-root.Mui-disabled': {
    color: 'rgba(28, 27, 31, 0.38)',
  },
  '& .MuiPickersDay-root.Mui-selected': {
    backgroundColor: `${CALENDAR_SELECTED} !important`,
    color: '#FFFFFF !important',
    fontWeight: 500,
  },
  '& .MuiPickersDay-today:not(.Mui-selected)': {
    borderColor: CALENDAR_TEXT,
  },
  '& .MuiPickersArrowSwitcher-button, & .MuiPickersCalendarHeader-switchViewButton': {
    color: CALENDAR_MUTED,
  },
}

export const mergeDesktopDatePickerSlots = (slots = {}) => ({
  ...slots,
  toolbar: slots.toolbar ?? HiddenPickerSlot,
  actionBar: slots.actionBar ?? HiddenPickerSlot,
})

export const mergeDesktopDatePickerSlotProps = (slotProps = {}) => ({
  ...slotProps,
  toolbar: {
    hidden: true,
    ...slotProps.toolbar,
  },
  actionBar: {
    ...slotProps.actionBar,
    actions: [],
  },
  layout: {
    ...slotProps.layout,
    sx: {
      '& .MuiPickersLayout-toolbar': { display: 'none' },
      '& .MuiPickersLayout-actionBar': { display: 'none' },
      '& .MuiDialogActions-root': { display: 'none' },
      ...(slotProps.layout?.sx || {}),
    },
  },
  popper: {
    disablePortal: false,
    ...slotProps.popper,
    sx: {
      ...desktopDatePickerPopperSx,
      ...(slotProps.popper?.sx || {}),
    },
  },
})

export const withDesktopDatePicker = (slotProps = {}, slots = {}) => ({
  closeOnSelect: true,
  slots: mergeDesktopDatePickerSlots(slots),
  slotProps: mergeDesktopDatePickerSlotProps(slotProps),
})
